import { Component } from 'react';
import {FormGroup} from 'react-bootstrap';
import {Form} from 'forms/rrf';
import RequiredInput from '../../common/form/elements/required-input';
import SelectWithFilter from '../../common/form/filtered-dropdown';
import Select from '../../common/form/elements/select';
import ArrowButton from '../../common/button-arrow';

class UpdateLevelForm extends Component {
  render() {
    const {
      levelValues, outletValue, outletValues, handleSelectChange,
      handleSubmit, updateButtonDisabled, handleSelectInputChange
    } = this.props;

    return (
      <Form model='deep.admin_update_level' onSubmit={payLoad => handleSubmit(payLoad)}>
        <FormGroup controlId="outlet">
          <label>
            Outlet*
          </label>
          <SelectWithFilter
            data={outletValues}
            model="deep.admin_update_level.outlet_id"
            onChange={handleSelectChange}
            onInputChange={handleSelectInputChange}
            placeholder="Select Outlet"
            value={outletValue}
          />
        </FormGroup>
        <FormGroup controlId="new_level">
          <Select
            emptyLabel="no override"
            hasEmptyValue
            label="Select override level"
            model=".new_level_id"
            values={levelValues}
          />
        </FormGroup>
        <FormGroup controlId="override_reason">
          <RequiredInput
            label="Reason for change"
            model=".reason"
          />
        </FormGroup>
        <FormGroup>
          <ArrowButton
            className="float-end"
            color="grey"
            disabled={updateButtonDisabled}
          >
            Update
          </ArrowButton>
        </FormGroup>
      </Form>
    );
  }
}

export default UpdateLevelForm;
